export default "__VITE_ASSET__Dp3T1C4l__"